import { MouseEventHandler, useState } from 'react'
import { IconButton } from '@mui/material'

import { QRCodeIcon } from 'src/assets/icons'
import { QRCodeModal } from './qr-code-modal.component'

interface IQRCodeButtonProps {
  id: string
  simpleProductId: string
}

const QRCodeButton = ({ id, simpleProductId }: IQRCodeButtonProps) => {
  const [open, setOpen] = useState(false)

  const handleClose: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    setOpen(false)
  }

  const handleOpen: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    setOpen(true)
  }

  return (
    <>
      <IconButton onClick={handleOpen}>
        <QRCodeIcon />
      </IconButton>
      <QRCodeModal
        handleClose={handleClose}
        open={open}
        productId={id}
        simpleProductId={simpleProductId}
      />
    </>
  )
}

export { QRCodeButton }
